import { render } from "./App.vue?vue&type=template&id=7791c222"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7791c222&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__